export default "__VITE_ASSET__Ck7giRZ8__"